import * as types from "../actions/actionTypes";
import initialState from "./initialState.js";

export default function abstractDataReducer(state = initialState, action) {
    const newState = { ...state };
    switch (action.type) {
        case types.LOAD_ALL_PRODUCT_SUCCESS:
            newState.productData = action.productData.data.result;
            return newState;
        case types.LOAD_ALL_COUNTRY_SUCCESS:
            newState.countryData = action.countryData.data.result;
            return newState;
        case types.LOAD_ALL_EXPLANATION_SUCCESS:
            newState.explanationData = action.explanationData.data.result;
            return newState;
        case types.LOAD_ALL_ALERTS_SUCCESS:
            newState.alertData = action.data;
            return newState;
        case types.LOAD_ALL_STATUS_SUCCESS:
            newState.statusData = action.statusData.data.result;
            return newState;
        case types.LOAD_ALL_ABSTRACT_DATA_SUCCESS:
            newState.abstractDataList = action.data.data;
            return newState;

        default:
            return state;
    }
}
